import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { combineLatest, forkJoin, Subject } from "rxjs";
import { filter, finalize, take, takeUntil } from "rxjs/operators";
import { ContextService } from "../../context/state/context.service";
import { EaredDoveService } from "../../eared-dove/eared-dove.service";
import { ParentHashTreePipe } from "../../pipes/parent-hash-tree/parent-hash-tree.pipe";

@Component({
  selector: "app-verbatim-details",
  templateUrl: "./verbatim-details.component.html",
  styleUrls: ["./verbatim-details.component.scss"],
  standalone: false,
})
export class VerbatimDetailsComponent implements OnInit, OnDestroy {
  @Input() verbatim: string;
  @Input() verbatimId: string;
  @Input() categoryNames: any;

  destroyed$ = new Subject<boolean>();

  loadingCategoryNames = false;

  constructor(
    private contextService: ContextService,
    private earedDoveService: EaredDoveService,
    public parentHashTreePipe: ParentHashTreePipe,
  ) {}

  ngOnInit() {
    if (this.categoryNames) {
      return;
    }

    this.contextService.allContext$
      .pipe(
        filter((context) => !!context?.c?.version?.uuid),
        take(1),
        takeUntil(this.destroyed$),
      )
      .subscribe((context) => {
        this.loadingCategoryNames = true;

        combineLatest([
          forkJoin([
            this.earedDoveService.getVerbatimCategories(
              context?.ds?.uuid,
              this.verbatimId,
              context?.ds?.source_type,
              context?.s?.version?.uuid,
              context?.t?.version?.uuid,
              context?.e?.version?.uuid,
              context?.i?.version?.uuid,
              context?.c?.version?.uuid,
              context?.c?.version?.version_data,
              context?.c?.version?.options,
            ),
            this.earedDoveService.getHashes(
              context?.c?.version?.version_data,
              context?.c?.version?.options,
              context?.s?.version?.uuid,
              context?.t?.version?.uuid,
              context?.e?.version?.uuid,
              context?.i?.version?.uuid,
            ),
          ]),
          this.contextService.categoryLookup$.pipe(
            filter((lookup) => !!lookup),
            take(1),
          ),
        ])
          .pipe(
            finalize(() => {
              this.loadingCategoryNames = false;
            }),
            takeUntil(this.destroyed$),
          )
          .subscribe(([[verbatimCategories, hashes], lookup]) => {
            const categories =
              verbatimCategories?.[0]?.verbatim_set?.[0]?.categories?.map(
                (category: any) => category.hash,
              ) || [];

            this.categoryNames =
              this.parentHashTreePipe.transform(categories, hashes, lookup) ??
              [];
          });
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
